import React from 'react';
import { ReadyToUseASEStationMessage } from '../common';

export const ContainerIsReadyToUse = {
  title: (
    <>
      <ReadyToUseASEStationMessage />
    </>
  ),
  type: 'info',
} as const;
